// Module
var code = "<dropbucket></dropbucket>\r\n<view-manager></view-manager>\r\n";
// Exports
export default code;